import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../assets/background.png";
import trophy from "../assets/trophy.png";
import { Scale } from 'react-scaling';


import {
  Button,
  GreenButton,
  RedButton
} from "../../../globals/components/button";

export default function RatingGameContainer({ ...props }) {
  const { children, lives, level, timer, endless, correctInRow, onBack, loading } = props;

  return (
    <ApplicationContainer>
      <Scale scaleTo={1720}>
        <div>
          <ApplicationHeader>
            <LeftHeader>
              <Score>{correctInRow}</Score>
            </LeftHeader>
            <CenterHeader>
              {level > 9 && endless == "endless" && lives > 0 && level < 15 ? (<Timer>Level: {level}<div/>{timer}</Timer>) : (<Timer>Level: {level}</Timer>)}
            </CenterHeader>
            <RightHeader>
              <Score>Lives: {lives}</Score>
              <Back onClick={onBack}>Back</Back>
            </RightHeader>
          </ApplicationHeader>
        </div>
      </Scale>
      {!loading ? (
        children
      ) : loading ? (
        <span>Loading</span>
      ) : (
            <ApplicationResult>
              <ResultImage>
                <div style={{ position: "relative", height: "300px" }}>
                  <Banner>Well Done!</Banner>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Button
                    onClick={() => props.onRestart()}
                    style={{ width: "40%", height: "60px", fontSize: "30px" }}
                  >
                    Play Again
              </Button>
                  <RedButton
                    onClick={onBack}
                    style={{ width: "40%", height: "60px", fontSize: "30px" }}
                  >
                    Back
              </RedButton>
                </div>
              </ResultImage>
              <ResultText>
                {/* <ResultScores> */}
                {/* <Result>
                <div>Score:</div>
                <ResultValue>{score}</ResultValue>
                <div style={{ color: "#42B231" }}>Correct:</div>
                <ResultValue>{correct}</ResultValue>

                <div style={{ color: "#EF3E37" }}>Incorrect:</div>
                <ResultValue>{incorrect}</ResultValue>
              </Result>
            </ResultScores> */}
              </ResultText>
            </ApplicationResult>
          )}
    </ApplicationContainer>
  );
}

const ApplicationContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: #2a64a4;
`;

const ApplicationHeader = styled.div`
  width: 100%;
  height: 60px;
  background: #683d8c;
  justify-content: space-around;
  display: flex;
`;

const LeftHeader = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
`;

const RightHeader = styled.div`
  width: 30%;
  display: flex;
`;

const ResultText = styled.div`
  background: #fff;
  border: solid #683d8c 2px;
  width: 50%;
  border-radius: 10px;
  padding: 10px;
  color: #683d8c;
  font-weight: 600;
  font-size: 1.2em;
`;

const ResultImage = styled.div`
  width: 40%;
  background-image: url(${trophy});
  background-size: auto;
  background-repeat: no-repeat;
  background-position: top;
  display: flex;
  flex-direction: column;
`;

const CenterHeader = styled.div`
  width: 30%;
  display: flex;
  justify-content: center;
`;

const Timer = styled.div`
  width: 200px;
  height: 80px;
  background: #ef3e37;
  text-align: center;
  font-size: 3em;
  font-weight: 600;
  color: #fff;
  line-height: 80px;
  margin-top: 0px;
  border-radius: 0px 0px 15px 15px;
  z-index: 11;
`;

const ApplicationBody = styled.div`
  width: 100%;
  height: 100%;
  background: #2a64a4;
  background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
`;

const ApplicationResult = styled.div`
  height: 100%;
  z-index: 10;
  background: #fff;
  background-image: url(${background});
  padding: 150px;
  font-size: 3em;
  border: solid 2px #683d8c;
  display: flex;
  justify-content: space-between;
`;

const IncorrectCount = styled.div`
  margin-top: 10px;
  width: 50px;
  height: 40px;
  background: #ef3e37;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  border-radius: 5px;
`;

const CorrectCount = styled.div`
  width: 50px;
  height: 40px;
  margin-top: 10px;
  background: #42b231;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  border-radius: 5px;
`;

const Score = styled.div`
  width: 150px;
  height: 40px;
  margin-top: 10px;
  background: #4b2e6b;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  border-radius: 20px;
`;

const Back = styled.div`
  width: 150px;
  height: 40px;
  margin-top: 10px;
  background: #4b2e6b;
  user-select: none;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  border-radius: 20px;
  &:hover {
    cursor: pointer;
  }
`;

const ResultScores = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  flex-direction: column;
`;

const Result = styled.div`
  display: flex;
`;
const ResultValue = styled.div`
  margin: 0px 20px;
  border: solid lightgray 2px;
  background: #fff;
  padding: 0px 15px;
`;

const Banner = styled.div`
  position: absolute;
  left: 50%;
  display: block;
  margin: 100px -200px;
  width: 400px;
  height: 60px;
  border: 1px solid #e88f12;
  font: normal 30px/60px;
  line-height: 60px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  background: rgba(255, 186, 32, 1);
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15) inset, 0 6px 10px rgba(0, 0, 0, 0.15);
  &::before,
  ::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: -70px;
    top: 24px;
    display: block;
    width: 40px;
    height: 0px;
    border: 30px solid #e88f12;
    border-right: 20px solid #c97e11;
    border-bottom-color: #e88f12;
    border-left-color: transparent;
    transform: rotate(-5deg);
  }

  &::after {
    left: auto;
    right: -70px;
    border-left: 20px solid #c97e11;
    border-right: 30px solid transparent;
    transform: rotate(5deg);
  }
`;
